import Vue from "vue";
import VueI18n from "vue-i18n";

import kk from "./locales/kk";
import ru from "./locales/ru";
import Cookies from "js-cookie";

Vue.use(VueI18n);

const savedLanguage = Cookies.get("zk_lng") || "ru";
const messages = {
  kk,
  ru,
};

const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: "ru",
  silentTranslationWarn: true,
  messages,
});

export default i18n;
